'use strict';
/*!
 * for Post slider Block
 *
 * @package tokai-univ
 * @deps swiper
 */

let isReady = false;

document.addEventListener( 'readystatechange', () => {
	// Already enabled.
	if ( isReady ) {
		return;
	}
	// If not enabled, check if DOM is ready.
	switch ( document.readyState ) {
		case 'loading':
			return;
		default:
			isReady = true;
			break;
	}
	const sliders = document.querySelectorAll( '.js-swiper-post-slider' );
	const slidersArray = Array.prototype.slice.call( sliders );
	if ( slidersArray.length ) {
		slidersArray.forEach( function ( postSliderElement, index ) {
			const slideElm = postSliderElement.querySelectorAll( '.swiper-container' );
			const slidePagi = postSliderElement.querySelectorAll( '.swiper-pagination' );
			const slidePrevBtn = postSliderElement.querySelectorAll( '.swiper-button-prev' );
			const slideNextBtn = postSliderElement.querySelectorAll( '.swiper-button-next' );
			slideElm[0].classList.add( 'sliderInstance-' + index );
			slidePagi[0].classList.add( 'pagination-' + index );
			slidePrevBtn[0].classList.add( 'sliderPrevBtn-' + index );
			slideNextBtn[0].classList.add( 'sliderNextBtn-' + index );
			//swiper initialize
			new Swiper( '.sliderInstance-' + index, {
				loop: true,
				uniqueNavElements: false,
				pagination: {
					el: '.pagination-' + index,
					clickable: true,
				},
				navigation: {
					nextEl: '.sliderNextBtn-' + index,
					prevEl: '.sliderPrevBtn-' + index,
				},
				autoplay: {
					delay: 4000,
				},
				a11y: {
					prevSlideMessage: '前のスライド - Previous slide',
					nextSlideMessage: '次のスライド - Next slide',
				},
			} );
		} );
	}
} );
